function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) 2018-2020 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagIE(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURf99Bf+CEAOiSwStUQa3VvPz8/j4+Pv7+/X19f7+/vHx8Vso+vkAAAF3SURBVDjL1Y9BasMwEEWlG9hXkDCULiU3yV6G0AMIQg9g5wQxOoCDb2ByAG98yv4Z2cKBqN22Lxkt8p/+KKJJfD4SZaIQf00I028NYZqmRwjhtXDuI1AyQrwd4PzcAGUvuKapMTjOod/YC7Vzrqkt5ty/FFzNQMsIFAHr6mNGSBz7rrthwF6wtbXO1njFsev7rr3RPDWwgRUWDW2L722/QqwNVHJARvdBAUqJr8SKxKHjkLRSltEoWHDUAgFRNFq6y8pzQ5ugpChRUWQEBKRQzWtBxBgjWDBWk3BPSApJgYDQkKH11nAfr/gdSIEnCM0GGsxpJK6kiCIiaMVqaH26EmxJLhd8mMTacMdBCwqK5SZolLyNCWznV9Cp1vtaVWt68UNK6ZGKPsjNByLvh5FXUEf8LxQZNio/EKStGxhllOICXQ0o8BfSxA7EWjEV0gtyWM+CUUnY2Avxus4LKlEty/LlZ0xGePd+nqOSEZYZFcSSExL/TfgGw6xR+sUX6KMAAAAASUVORK5CYII=",
    alt: "IE"
  }, props));
}